import React, { useEffect } from "react";
import vary from "../../../web/assets/images/vary.jpeg";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setAuth } from "../../../features/Dashboard/Authentication";
import { getDashboardNotification } from "../../../features/Global/DashboardNotification";
import Toast from "../Cards/Toast";
import Cookies from "js-cookie";
import {
  ArrowPathIcon,
  BellAlertIcon,
  BellSnoozeIcon,
  MoonIcon,
  SunIcon,
  UserCircleIcon,
  XCircleIcon,
} from "@heroicons/react/24/outline";
import axios from "axios";
const Header = (open, setOpen) => {
  const [Popover, setPopover] = useState(false);
  const [notification, setNotification] = useState(false);
  const user = JSON?.parse(Cookies.get("User"));
  const notificationList = useSelector(
    (state) => state?.DashboardNotification?.data
  );
  const navigate = useNavigate();
  const handlePoover = (props) => {
    setPopover(!props);
  };
  const handlePooverNotification = (props) => {
    setNotification(!props);
  };
  const handleNotificationState = (id) => {
    const data = {};
    data.seen = true;
    data.id = id;
    axios
      .put(`api/DashboardNotifications`, data, config)
      .then((r) => {
        // console.log(r);
        dispatch(getDashboardNotification());
      })
      .catch((e) => console.log(e));
  };
  const dispatch = useDispatch();
  const handleLogout = () => {
    Cookies.remove("dashboardToken");
    Cookies.remove("User");
    dispatch(setAuth(false));

    navigate("/dashboard/login");
  };
  const [toggle, setToggle] = useState(false);

  const [dark, setDark] = useState(false);

  const body = document.querySelector("body"),
    sidebar = body.querySelector("nav"),
    // toggle = body.querySelector(".toggle"),
    // searchBtn = body.querySelector(".search-box"),
    // modeSwitch = body.querySelector(".toggle-switch"),
    modeText = body.querySelector(".mode-text");

  const handleToggle = () => {
    // sidebar.classNameList.toggle("close");
    setToggle(!toggle);
  };
  const handleSearchbox = () => {
    // sidebar.classNameList.toggle("close");
  };
  const handleSwitch = () => {
    setDark(!dark);
    // document.body.classList.remove('Dark mode');
    // document.body.classList.add('Dark mode');

    body.classList.toggle("dark");

    if (document.body.classList.contains("dark")) {
      // document.body.innerText = "Light mode";
    } else {
      // document.body.innerText = "Dark mode";
    }
    Text.innerText = "Dark mode";
    // }
  };
  // Toast
  const [toast, setToast] = useState(false);
  const [error, setError] = useState(false);
  const [message, setMessage] = useState("");
  const config = {
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
      Authorization: `Bearer ${Cookies.get("dashboardToken")}`,
    },
  };
  const [sync, setSync] = useState(false);
  const handleSync = () => {
    setSync(true);
    axios
      .get("api/AppConfigs/SyncDatabases", config)
      .then((r) => {
        // console.log(r);
        setToast(true);
        setSync(false);
        setMessage("Sync done successfully.");
      })
      .catch((e) => {
        console.log(e);
        setSync(false);
        setError(true);
        setMessage("Sync failed.");
      });
  };
  useEffect(() => {
    dispatch(getDashboardNotification());
    if (localStorage.getItem("i18nextLng") !== "en-US") {
      // Cookies.set('i18nextLng', 'en-US', { expires: 7 })
      localStorage.setItem("i18nextLng", "ku");
    }
  }, [localStorage.getItem("i18nextLng")]);

  return (
    <div
      className="relative flex flex-col justify-end w-full h-full p-2 px-3 bg-white dark:bg-gray-900 ltr"
      style={{ direction: "ltr" }}
    >
      <div className="relative flex items-center justify-end w-full p-1 space-x-4">
        {/* <button className="flex items-center p-2 text-gray-400 bg-white rounded-full shadow hover:text-gray-700 text-md">
          <svg
            width="20"
            height="20"
            className=""
            fill="currentColor"
            viewBox="0 0 1792 1792"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M1520 1216q0-40-28-68l-208-208q-28-28-68-28-42 0-72 32 3 3 19 18.5t21.5 21.5 15 19 13 25.5 3.5 27.5q0 40-28 68t-68 28q-15 0-27.5-3.5t-25.5-13-19-15-21.5-21.5-18.5-19q-33 31-33 73 0 40 28 68l206 207q27 27 68 27 40 0 68-26l147-146q28-28 28-67zm-703-705q0-40-28-68l-206-207q-28-28-68-28-39 0-68 27l-147 146q-28 28-28 67 0 40 28 68l208 208q27 27 68 27 42 0 72-31-3-3-19-18.5t-21.5-21.5-15-19-13-25.5-3.5-27.5q0-40 28-68t68-28q15 0 27.5 3.5t25.5 13 19 15 21.5 21.5 18.5 19q33-31 33-73zm895 705q0 120-85 203l-147 146q-83 83-203 83-121 0-204-85l-206-207q-83-83-83-203 0-123 88-209l-88-88q-86 88-208 88-120 0-204-84l-208-208q-84-84-84-204t85-203l147-146q83-83 203-83 121 0 204 85l206 207q83 83 83 203 0 123-88 209l88 88q86-88 208-88 120 0 204 84l208 208q84 84 84 204z"></path>
          </svg>
        </button> */}
        {/* <button className="flex items-center p-2 text-gray-400 bg-white rounded-full shadow hover:text-gray-700 text-md dark:bg-indigo-600 dark:text-white">
          <svg
            width="20"
            height="20"
            className="text-gray-400 dark:text-white"
            fill="currentColor"
            viewBox="0 0 1792 1792"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M912 1696q0-16-16-16-59 0-101.5-42.5t-42.5-101.5q0-16-16-16t-16 16q0 73 51.5 124.5t124.5 51.5q16 0 16-16zm816-288q0 52-38 90t-90 38h-448q0 106-75 181t-181 75-181-75-75-181h-448q-52 0-90-38t-38-90q50-42 91-88t85-119.5 74.5-158.5 50-206 19.5-260q0-152 117-282.5t307-158.5q-8-19-8-39 0-40 28-68t68-28 68 28 28 68q0 20-8 39 190 28 307 158.5t117 282.5q0 139 19.5 260t50 206 74.5 158.5 85 119.5 91 88z"></path>
          </svg>
        </button> */}
        <span className="w-1 h-8 duration-300 bg-gray-200 rounded-lg dark:bg-gray-300"></span>
        <span className="group" onClick={() => handleSync()}>
          <ArrowPathIcon
            className={`inline w-8 dark:text-gray-300 dark:group-hover:bg-gray-500 group-hover:bg-gray-200 duration-500 p-1 rounded-full ${
              sync === true ? "animate-spin" : ""
            }`}
            onClick={() => handleSync()}
          />
        </span>
        <span
          className="group"
          onClick={() => {
            handleSwitch();
          }}
        >
          {dark === false ? (
            <>
              <SunIcon className="inline w-8 p-1 mx-1 duration-500 rounded-full dark:text-gray-300 dark:group-hover:bg-gray-500 group-hover:bg-gray-200" />{" "}
            </>
          ) : (
            <>
              <MoonIcon className="inline w-8 p-1 mx-1 text-gray-300 duration-500 rounded-full dark:group-hover:bg-gray-500 dark dark:text-blue-100 group-hover:bg-gray-200" />
            </>
          )}
        </span>
        {/* <Link to="#" className="relative block">
          <img
            alt="profil"
            src={vary}
            className="object-cover w-10 h-10 mx-auto rounded-full "
          />
        </Link> */}
        <div className="relative inline-block text-left">
          <button
            onClick={() => handlePooverNotification(notification)}
            type="button"
            className="flex items-center justify-center w-full px-4 py-2 text-sm font-medium text-gray-700 bg-white rounded-md shadow-sm dark:bg-gray-800 dark:text-indigo-50 hover:bg-gray-50 dark:hover:bg-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-gray-500"
            id="options-menu"
          >
            {/* Account */}
            {/* <img src={user?.image} className="w-8 h-8 rounded-full" /> */}
            <span className="px-1 group">
              {" "}
              <BellAlertIcon className="w-8 p-1 duration-500 rounded-full group-hover:bg-gray-200" />
            </span>
            {/* <svg
                width="20"
                height="20"
                fill="currentColor"
                viewBox="0 0 1792 1792"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M1408 704q0 26-19 45l-448 448q-19 19-45 19t-45-19l-448-448q-19-19-19-45t19-45 45-19h896q26 0 45 19t19 45z"></path>
              </svg> */}
          </button>
          <div className="absolute right-0 mt-2 origin-top-right bg-white rounded-md shadow-lg w-2xl dark:bg-gray-800 ring-1 ring-black ring-opacity-5 dark:ring-white dark:ring-opacity-50">
            {notification && (
              <div
                className="flex py-1 divide-y divide-gray-100 "
                role="menu"
                aria-orientation="vertical"
                aria-labelledby="options-menu"
              >
                <div
                  className="flex items-center px-12 py-2 overflow-y-scroll text-gray-700 min-w-2xl text-md dark:text-gray-100 h-96"
                  role="menuitem"
                >
                  <div className="flow-root">
                    <ul
                      role="list"
                      className="min-w-full divide-y divide-gray-200 dark:divide-gray-700"
                    >
                      {notificationList?.filter((a) => a.seen === false)
                        ?.length < 1 ? (
                        <>
                          <li className="flex min-w-full py-3 sm:py-4 hover:bg-gray-100 hover:text-gray-900 dark:hover:text-white dark:hover:bg-gray-600">
                            <span className="items-center inline space-x-4">
                              <span className="">
                                <span className="text-sm font-medium text-gray-900 truncate dark:text-white">
                                  <span className="items-center justify-center inline w-12 h-12 p-2 border border-red-100 rounded-full bg-red-50">
                                    <BellSnoozeIcon className="inline w-6 text-rose-600 animate-pulse" />
                                  </span>
                                  <span className="mx-2">
                                    No New Notification
                                  </span>
                                </span>
                              </span>
                            </span>
                          </li>
                        </>
                      ) : (
                        <>
                          {notificationList
                            ?.filter((a) => a.seen === false)
                            ?.map((item) => (
                              <>
                                <li className="w-full py-3 list-none sm:py-4">
                                  <span className="flex items-center ">
                                    <div className="flex-1 min-w-full">
                                      <p className="text-sm font-medium text-gray-900 truncate dark:text-white">
                                        {/* <BellAlertIcon className="inline w-6 mx-2 text-blue-500" /> */}
                                        {item?.message}
                                      </p>
                                      <p className="text-sm text-gray-500 truncate dark:text-gray-400">
                                        {new Date(
                                          item?.timeReceived
                                        ).toLocaleString()}
                                      </p>
                                    </div>
                                    <div
                                      onClick={() =>
                                        handleNotificationState(item?.id)
                                      }
                                      className="inline-flex items-center p-2 text-base font-semibold text-gray-900 rounded-full dark:text-white hover:text-rose-600 hover:bg-rose-100"
                                    >
                                      <XCircleIcon
                                        onClick={() =>
                                          handleNotificationState(item?.id)
                                        }
                                        className="inline w-6 my-auto duration-300 rounded-full text-rose-500"
                                      />{" "}
                                    </div>
                                  </span>
                                </li>
                              </>
                            ))}
                        </>
                      )}
                    </ul>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        {/* <Notification open={notification} setOpen={setNotification} /> */}
        <div className="relative inline-block text-left">
          <div>
            <button
              onClick={() => handlePoover(Popover)}
              type="button"
              className="flex items-center justify-center w-full px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm dark:bg-gray-800 dark:text-indigo-50 hover:bg-gray-50 dark:hover:bg-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-gray-500"
              id="options-menu"
            >
              {/* Account */}
              <img src={user?.image} className="w-8 h-8 rounded-full" />
              <span className="px-1"> {user?.email}</span>
              <svg
                width="20"
                height="20"
                fill="currentColor"
                viewBox="0 0 1792 1792"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M1408 704q0 26-19 45l-448 448q-19 19-45 19t-45-19l-448-448q-19-19-19-45t19-45 45-19h896q26 0 45 19t19 45z"></path>
              </svg>
            </button>
          </div>
          <div className="absolute right-0 w-56 mt-2 origin-top-right bg-white rounded-md shadow-lg dark:bg-gray-800 ring-1 ring-black ring-opacity-5 dark:ring-white dark:ring-opacity-50">
            {Popover && (
              <div
                className="py-1 divide-y divide-gray-100"
                role="menu"
                aria-orientation="vertical"
                aria-labelledby="options-menu"
              >
                {/* <Link
                  to="#"
                  className="flex items-center block px-4 py-2 text-gray-700 text-md hover:bg-gray-100 hover:text-gray-900 dark:text-gray-100 dark:hover:text-white dark:hover:bg-gray-600"
                  role="menuitem"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    className="flex-shrink-0 w-6 h-6 mr-2 dark:text-white"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z"
                    />
                  </svg>
                  <span className="flex flex-col">
                    <span>User</span>
                  </span>
                </Link> */}
                <button
                  onClick={handleLogout}
                  className="flex items-center block w-full px-4 py-2 text-left text-gray-700 text-md hover:bg-gray-100 hover:text-gray-900 dark:text-gray-100 dark:hover:text-white dark:hover:bg-gray-600"
                  role="menuitem"
                >
                  {/* <svg
                    width="20"
                    height="20"
                    fill="currentColor"
                    className="flex-shrink-0 w-6 h-6 mr-2 dark:text-white"
                    viewBox="0 0 2304 1792"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M1119 341q-128-85-281-85-103 0-197.5 40.5t-162.5 108.5-108.5 162-40.5 197q0 104 40.5 198t108.5 162 162 108.5 198 40.5q153 0 281-85-131-107-178-265.5t.5-316.5 177.5-265zm33 24q-126 99-172 249.5t-.5 300.5 172.5 249q127-99 172.5-249t-.5-300.5-172-249.5zm33-24q130 107 177.5 265.5t.5 317-178 264.5q128 85 281 85 104 0 198-40.5t162-108.5 108.5-162 40.5-198q0-103-40.5-197t-108.5-162-162.5-108.5-197.5-40.5q-153 0-281 85zm741 722h7v-3h-17v3h7v17h3v-17zm29 17h4v-20h-5l-6 13-6-13h-5v20h3v-15l6 13h4l5-13v15zm-8 440v2h-5v-3h5v1zm0 9h3l-4-5h2l1-1q1-1 1-3t-1-3l-1-1h-9v13h3v-5h1zm-1262-68q0-19 11-31t30-12q18 0 29 12.5t11 30.5q0 19-11 31t-29 12q-19 0-30-12t-11-31zm473-44q30 0 35 32h-70q5-32 35-32zm356 44q0-19 11-31t29-12 29.5 12.5 11.5 30.5q0 19-11 31t-30 12q-18 0-29-12t-11-31zm272 0q0-18 11.5-30.5t29.5-12.5 29.5 12.5 11.5 30.5q0 19-11.5 31t-29.5 12-29.5-12.5-11.5-30.5zm158 72q-2 0-4-1-1 0-3-2t-2-3q-1-2-1-4 0-3 1-4 0-2 2-4l1-1q2 0 2-1 2-1 4-1 3 0 4 1l4 2 2 4v1q1 2 1 3l-1 1v3l-1 1-1 2q-2 2-4 2-1 1-4 1zm-1345-4h30v-85q0-24-14.5-38.5t-39.5-15.5q-32 0-47 24-14-24-45-24-24 0-39 20v-16h-30v135h30v-75q0-36 33-36 30 0 30 36v75h29v-75q0-36 33-36 30 0 30 36v75zm166 0h29v-135h-29v16q-17-20-43-20-29 0-48 20t-19 51 19 51 48 20q28 0 43-20v17zm178-41q0-34-47-40l-14-2q-23-4-23-14 0-15 25-15 23 0 43 11l12-24q-22-14-55-14-26 0-41 12t-15 32q0 33 47 39l13 2q24 4 24 14 0 17-31 17-25 0-45-14l-13 23q25 17 58 17 29 0 45.5-12t16.5-32zm130 34l-8-25q-13 7-26 7-19 0-19-22v-61h48v-27h-48v-41h-30v41h-28v27h28v61q0 50 47 50 21 0 36-10zm86-132q-29 0-48 20t-19 51q0 32 19.5 51.5t49.5 19.5q33 0 55-19l-14-22q-18 15-39 15-34 0-41-33h101v-12q0-32-18-51.5t-46-19.5zm159 0q-23 0-35 20v-16h-30v135h30v-76q0-35 29-35 10 0 18 4l9-28q-9-4-21-4zm30 71q0 31 19.5 51t52.5 20q29 0 48-16l-14-24q-18 13-35 12-18 0-29.5-12t-11.5-31 11.5-31 29.5-12q19 0 35 12l14-24q-20-16-48-16-33 0-52.5 20t-19.5 51zm245 68h30v-135h-30v16q-15-20-42-20-29 0-48.5 20t-19.5 51 19.5 51 48.5 20q28 0 42-20v17zm133-139q-23 0-35 20v-16h-29v135h29v-76q0-35 29-35 10 0 18 4l9-28q-8-4-21-4zm140 139h29v-190h-29v71q-15-20-43-20t-47.5 20.5-19.5 50.5 19.5 50.5 47.5 20.5q29 0 43-20v17zm78-20l-2 1h-3q-2 1-4 3-3 1-3 4-1 2-1 6 0 3 1 5 0 2 3 4 2 2 4 3t5 1q4 0 6-1 0-1 2-2l2-1q1-1 3-4 1-2 1-5 0-4-1-6-1-1-3-4 0-1-2-2l-2-1q-1 0-3-.5t-3-.5zm360-1253v1280q0 52-38 90t-90 38h-2048q-52 0-90-38t-38-90v-1280q0-52 38-90t90-38h2048q52 0 90 38t38 90z"></path>
                  </svg> */}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    className="flex-shrink-0 w-6 h-6 mr-2 dark:text-white"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15m3 0l3-3m0 0l-3-3m3 3H9"
                    />
                  </svg>

                  <button onClick={handleLogout} className="flex flex-col">
                    Logout
                  </button>
                </button>

                {/* <Link
                  to="#"
                  className="flex items-center block px-4 py-2 text-gray-700 text-md hover:bg-gray-100 hover:text-gray-900 dark:text-gray-100 dark:hover:text-white dark:hover:bg-gray-600"
                  role="menuitem"
                >
                  <svg
                    width="20"
                    height="20"
                    fill="currentColor"
                    className="flex-shrink-0 w-6 h-6 mr-2 dark:text-white"
                    viewBox="0 0 2304 1792"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M745 906q0 37-25.5 61.5t-62.5 24.5q-29 0-46.5-16t-17.5-44q0-37 25-62.5t62-25.5q28 0 46.5 16.5t18.5 45.5zm785-149q0 42-22 57t-66 15l-32 1 17-107q2-11 13-11h18q22 0 35 2t25 12.5 12 30.5zm351 149q0 36-25.5 61t-61.5 25q-29 0-47-16t-18-44q0-37 25-62.5t62-25.5q28 0 46.5 16.5t18.5 45.5zm-1368-171q0-59-38.5-85.5t-100.5-26.5h-160q-19 0-21 19l-65 408q-1 6 3 11t10 5h76q20 0 22-19l18-110q1-8 7-13t15-6.5 17-1.5 19 1 14 1q86 0 135-48.5t49-134.5zm309 312l41-261q1-6-3-11t-10-5h-76q-14 0-17 33-27-40-95-40-72 0-122.5 54t-50.5 127q0 59 34.5 94t92.5 35q28 0 58-12t48-32q-4 12-4 21 0 16 13 16h69q19 0 22-19zm447-263q0-5-4-9.5t-9-4.5h-77q-11 0-18 10l-106 156-44-150q-5-16-22-16h-75q-5 0-9 4.5t-4 9.5q0 2 19.5 59t42 123 23.5 70q-82 112-82 120 0 13 13 13h77q11 0 18-10l255-368q2-2 2-7zm380-49q0-59-38.5-85.5t-100.5-26.5h-159q-20 0-22 19l-65 408q-1 6 3 11t10 5h82q12 0 16-13l18-116q1-8 7-13t15-6.5 17-1.5 19 1 14 1q86 0 135-48.5t49-134.5zm309 312l41-261q1-6-3-11t-10-5h-76q-14 0-17 33-26-40-95-40-72 0-122.5 54t-50.5 127q0 59 34.5 94t92.5 35q29 0 59-12t47-32q0 1-2 9t-2 12q0 16 13 16h69q19 0 22-19zm218-409v-1q0-14-13-14h-74q-11 0-13 11l-65 416-1 2q0 5 4 9.5t10 4.5h66q19 0 21-19zm-1784 134q-5 35-26 46t-60 11l-33 1 17-107q2-11 13-11h19q40 0 58 11.5t12 48.5zm1912-516v1280q0 52-38 90t-90 38h-2048q-52 0-90-38t-38-90v-1280q0-52 38-90t90-38h2048q52 0 90 38t38 90z"></path>
                  </svg>
                  <span className="flex flex-col">
                    <span>Paypal</span>
                  </span>
                </Link> */}
              </div>
            )}
          </div>
        </div>
        {toast && (
          <Toast Text={message} Type={"secondary"} setOpen={setToast} />
        )}
        {error && <Toast Text={message} Type={"rose"} setOpen={setError} />}{" "}
      </div>
    </div>
  );
};

export default Header;
